import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "avertissementEcran",
  class: "flex flex-col fixed top-0 left-0 w-screen h-screen justify-center items-center bg-gray-900 z-50"
}
const _hoisted_2 = { class: "text-7xl font-semibold" }
const _hoisted_3 = { class: "text-lg text-center mt-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectLangage = _resolveComponent("SelectLangage")!

  return (_ctx.avertissementDisplay)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('avertissementEcran.avertissement')), 1),
        _createVNode(_component_SelectLangage, { class: "w-1/6 m-5 mt-10 z-10 bg-green-600 hover:bg-green-700" }),
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.$t('avertissementEcran.description.1')) + " ", 1),
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('avertissementEcran.description.2')) + " ", 1),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('avertissementEcran.description.3')) + " ", 1),
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('avertissementEcran.description.4')), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchAvertissementDisplay())),
          class: "w-1/10 h-12 bg-green-600 rounded text-lg font-medium mt-10 outline-none"
        }, _toDisplayString(_ctx.$t('avertissementEcran.continuer')), 1)
      ]))
    : _createCommentVNode("", true)
}